<template>
  <tg-tool-layout title="查詢">
    <template slot="icon">
      <i class="el-icon-search"></i>
    </template>
    <slot></slot>
    <tg-search-btn
      @click.native="handleSearch"
      :disabled="disabled"
    ></tg-search-btn>
    <tg-clear-btn
      @click.native="handleClear"
      v-if="showClearBtn"
      :disabled="clearDisabled"
    ></tg-clear-btn>
    <slot name="after"></slot>
  </tg-tool-layout>
</template>

<script>
import TgToolLayout from "@/layout/TgToolLayout";
import TgSearchBtn from "@/components/button/TgSearchBtn";
import TgClearBtn from "@/components/button/TgClearBtn";

export default {
  components: {
    TgSearchBtn,
    TgClearBtn,
    TgToolLayout,
  },
  props: {
    data: Object,
    classes: Object,
    showClearBtn: Boolean,
    clearDisabled: Boolean,
    disabled: Boolean,
  },
  methods: {
    handleSearch() {
      this.$emit("on-submit", this.data);
      this.$store.commit("TOOL_DIALOG_STATUS", false);
    },
    handleClear() {
      this.$emit("on-clear", this.data);
      this.$store.commit("TOOL_DIALOG_STATUS", false);
    },
  },
};
</script>
